import React from 'react';
import {
  useLocation,
  Link,
} from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import config from '@/configs/config';
import { useShoppingCartContext } from '@/contexts/useShoppingCartContext';
import { LazyLoadingComponent } from '@/../LazyLoading';

const useStyles = makeStyles((theme) => ({
  label: {
    paddingTop: theme.spacing(0.2),
    paddingBottom: theme.spacing(0.2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    textAlign: 'center',
    borderRadius: theme.spacing(0.5),
  },
  cardMedia: {
    height: 190,
  },
  normalLabel: {
    backgroundColor: theme.palette.success.main,
  },
  almostExpiredLabel: {
    backgroundColor: theme.palette.warning.main,
  },
  cardContent: {
    padding: theme.spacing(1),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
  disabled: {
    backgroundColor: theme.palette.action.disabled,
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: 10,
  },
  disabledText: {
    alignItems: 'center',
    color: theme.palette.common.white,
    display: 'flex',
    fontSize: theme.typography.h6.fontSize,
    justifyContent: 'center',
    position: 'relative',
  },
  imageContainer: {
    backgroundColor: theme.palette.grey[300],
    paddingBottom: '100%',
    position: 'relative',
  },
  image: {
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },
  price: {
    fontSize: theme.typography.subtitle1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.error.dark,
  },
  addToCartButton: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(0, 1),
    borderRadius: 5,
  },
}));

const PreOrderCard = ({
  data,
  linkTo,
  preOrderId,
  showAddToCartButton = true,
}) => {
  const location = useLocation();
  const classes = useStyles();
  const now = new Date().getTime();

  const {
    shoppingCart,
    addPreOrderToShoppingCart,
  } = useShoppingCartContext();

  const { minimumPurchaseAmount } = data || {};

  return (
    <Link to={linkTo || `${location.pathname}/${preOrderId}`}>
      <Card style={{ height: '100%', textAlign: 'left' }}>
        <CardActionArea style={{ height: '100%' }}>
          <CardContent className={classes.cardContent}>
            {
              data.registerStartTime > now && (
                <div className={classes.disabled}>
                  <div className={classes.disabledText}>
                    預購即將開始
                  </div>
                </div>
              )
            }
            {
              data.registerEndTime < now && (
                <div className={classes.disabled}>
                  <div className={classes.disabledText}>
                    預購已截止
                  </div>
                </div>
              )
            }
            <div className={classes.imageContainer}>
              <div className={classes.image}>
                {
                  data.coverImage && (
                    <LazyLoadingComponent>
                      <img
                        style={{ objectFit: 'cover' }}
                        width="100%"
                        height="100%"
                        src={`${config.RESOURCE_URI}${data.coverImage}`}
                        alt=""
                      />
                    </LazyLoadingComponent>
                  )
        }
              </div>
            </div>
            <Grid container style={{ marginTop: 8 }}>
              <Grid item xs={12}>
                <Typography
                  className={classes.title}
                  variant="subtitle1"
                  noWrap
                >
                  {data.title}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" noWrap>
                  {data.slogan}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" noWrap>
                  {data.spec}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container justify="space-between" alignItems="flex-end">
                  <Grid item>
                    <Typography variant="subtitle2" style={{ textDecoration: 'line-through' }}>
                      {`原價$${data.priceOriginal}`}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <div className={classes.price}>
                      {`優惠價$${data.basicSalePrice}`}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              {showAddToCartButton && (
              <Grid item xs={12}>
                <Grid container justify="space-between" alignItems="flex-end">
                  <Grid item />
                  <Grid item>
                    {
                      (() => {
                        const isPreOrderInShoppingCart = !!shoppingCart[preOrderId];
                        const buttonColor = isPreOrderInShoppingCart ? 'lightgrey' : 'black';
                        return (
                          <div
                            style={{
                              border: `2px solid ${buttonColor}`,
                              color: buttonColor,
                            }}
                            className={classes.addToCartButton}
                            onClick={(event) => {
                              event.stopPropagation();
                              event.preventDefault();
                              if (!isPreOrderInShoppingCart) {
                                addPreOrderToShoppingCart({
                                  amount: minimumPurchaseAmount || 1,
                                  preOrderId,
                                });
                              }
                            }}
                          >
                            <Typography variant="caption" fontSize="5px">加入購物車</Typography>
                          </div>
                        );
                      })()
                    }
                  </Grid>
                </Grid>
              </Grid>
              )}
            </Grid>
          </CardContent>
        </CardActionArea>
      </Card>
    </Link>
  );
};

export default PreOrderCard;
